// features/admin/drivingSchool/Slice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { POST } from "../../../utils/Methods";
import { APIS } from "../../../utils/APIS";
import { IDS } from "../../../utils/IDS";

// 🔹 Async Thunk for submitting Driving School details
export const SubmitSchoolDetails = createAsyncThunk(
  "drivingSchool/submit",
  async (data, { rejectWithValue }) => {
    try {
      const { user_id, school_name, rto, gst_no } = data;

      // Build query string dynamically
      const query = `?user_id=${user_id}&school_name=${encodeURIComponent(
        school_name
      )}&RTO=${encodeURIComponent(rto)}&GST_no=${encodeURIComponent(gst_no)}`;

      const res = await POST(`${APIS.Register.SUBMIT_DETAILS}${query}`);

      console.log("Driving School Response:", res);
      return res;
    } catch (error) {
      console.error("Driving School API error:", error);
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);


// 🔹 Slice
const drivingSchoolSlice = createSlice({
  name: "drivingSchool",
  initialState: {
    loading: false,
    success: false,
    error: null,
    data: null, // store API response if needed
  },
  reducers: {
    resetDrivingSchoolState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(SubmitSchoolDetails.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(SubmitSchoolDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.data = action.payload; 
      })
      .addCase(SubmitSchoolDetails.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export const { resetDrivingSchoolState } = drivingSchoolSlice.actions;

export default drivingSchoolSlice.reducer;
